/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoalResponse
 */
export interface GoalResponse {
    /**
     * 
     * @type {string}
     * @memberof GoalResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GoalResponse
     */
    goalResult: string;
    /**
     * 
     * @type {Date}
     * @memberof GoalResponse
     */
    achievementDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GoalResponse
     */
    clientId: string;
}

/**
 * Check if a given object implements the GoalResponse interface.
 */
export function instanceOfGoalResponse(value: object): value is GoalResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('goalResult' in value) || value['goalResult'] === undefined) return false;
    if (!('achievementDate' in value) || value['achievementDate'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function GoalResponseFromJSON(json: any): GoalResponse {
    return GoalResponseFromJSONTyped(json, false);
}

export function GoalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'goalResult': json['goalResult'],
        'achievementDate': (new Date(json['achievementDate'])),
        'clientId': json['clientId'],
    };
}

export function GoalResponseToJSON(json: any): GoalResponse {
    return GoalResponseToJSONTyped(json, false);
}

export function GoalResponseToJSONTyped(value?: GoalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'goalResult': value['goalResult'],
        'achievementDate': `${value['achievementDate'].getFullYear()}-${String(value['achievementDate'].getMonth()+1).padStart(2,'0')}-${String(value['achievementDate'].getDate()).padStart(2,'0')}`,
        'clientId': value['clientId'],
    };
}

